import { Box } from '~/commonComponents/Box';
import { Column } from '~/commonComponents/Column';
import { EmptyScreen } from '~/commonComponents/EmptyScreen/EmptyScreen';
import { Text } from '~/commonComponents/Text';
import { EmptyHighlyRatedIcon } from '~/images/emptyScreenIcons';
import { Colors } from '~/themes/colors';
import { ProfessionalList } from '../ProfessionalList';
import { IProfessionalTabPanelProps } from '../types';
import { useAppSelector } from '~/hooks/useAppSelector';
import { IUser } from '~/models';

export const HighlyRatedTabPanel = ({
  isInviting,
  isLoading,
  selectedProfessionals,
  onClosePopup,
  onSelectProfessionals,
  onSentInvitations,
  isSelectionMode,
  profession,
}: IProfessionalTabPanelProps) => {
  const professionals = useAppSelector(
    (state) =>
      state.user.highlyRatedProfessionals?.data
        ?.map(
          (it) =>
            ({
              full_name: it.professional.fullName,
              id: it.professional.id,
              isAvailable: true,
              profile_image: it.professional.profileImage,
              profession: it.job.profession,
              professions: it.professional.professions,
            }) as IUser & { professions: string[] },
        )
        .filter((professional: any) =>
          profession ? professional.professions?.includes(profession) : true,
        ) || [],
  );

  const isEmpty = !isLoading && professionals.length === 0;

  return (
    <Column flex={1}>
      {!isEmpty && !isLoading && (
        <Text textAlign="center" italic color={Colors.neutral_500}>
          Invite the professionals highly rated by your office. They will be
          <br />
          confirmed once they accept the offer at the listed rate and time.
        </Text>
      )}

      <Box flex={1}>
        <ProfessionalList
          EmptyComponent={
            // @ts-expect-error -- EmptyScreen still written in JavaScript
            <EmptyScreen
              Icon={EmptyHighlyRatedIcon}
              width={420}
              description={
                <Column>
                  <Text fontSize={18} bold marginBottom={20} textAlign="center">
                    No Highly-Rated Professionals
                  </Text>
                  It looks like you have not rated any professionals with an average rating greater
                  than 4.2 yet! There are two ways to add professionals to this list:
                  <ul
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 24,
                      marginTop: 20,
                      marginLeft: -20,
                    }}
                  >
                    <li>
                      <b>End-of-day review:</b> Leave a rating for a professional during the end of
                      the day review.
                    </li>
                    <li>
                      <b>Professional Hub:</b> Add a rating for a professional you recently worked
                      with on the “Recent Professionals” tab.
                    </li>
                  </ul>
                </Column>
              }
              descriptionStyle={{
                textAlign: 'left',
              }}
            />
          }
          hideSelectAllButton
          isEmpty={isEmpty}
          isInviting={isInviting}
          isLoading={isLoading}
          professionals={professionals}
          selectedProfessionals={selectedProfessionals}
          selectedProfession={profession}
          onClose={onClosePopup}
          onSelectProfessionals={onSelectProfessionals}
          onSentInvitations={onSentInvitations}
          confirmButtonText={isSelectionMode ? 'Confirm' : undefined}
        />
      </Box>
    </Column>
  );
};
